import { IconButton, useIsMobile } from '@grupoboticario/flora-react'
import { ThreeLinkedDotsIcon } from '@grupoboticario/flora-react-icons'
import { GoogleAnalyticsService, ModalSocialShare } from '@grupoboticario/barril-del-chavo'
import { Suspense, useState } from 'react'
import { useMagazine, useQueryParams, useReseller } from 'src/hooks'
import { getConfig } from 'src/helpers'
import { HeaderCatalogVariants } from 'src/@enums'
import { LoadingFull } from 'src/components/atoms'

const { businessUnit } = getConfig()

const getModalShareText = (catalogSlug: string, page: string) => {
  const urlOrigin = window.location.origin

  return `Acesse o Catálogo Digital da Minha Loja! ${urlOrigin}/${catalogSlug}/catalogo?page=${page}`
}

export const CustomModalSocialShare = () => {
  const [openShareModal, setOpenShareModal] = useState(false)

  const { isGenericUser, data: reseller } = useReseller()

  const { data: magazine } = useMagazine()

  const isMobile = useIsMobile()

  const queryParams = useQueryParams()

  const currentPage = queryParams.get('page') || '1'

  const pageIndex = parseInt(currentPage, 10) - 1

  const catalogPageUrl = magazine?.pages[pageIndex]?.image || ''

  const shouldShowComponent = isMobile && !isGenericUser && reseller

  const handleOpenShareModal = () => {
    setOpenShareModal(true)
    GoogleAnalyticsService.event({
      event: 'event',
      eventCategory: `minhaloja:${businessUnit}:geral`,
      eventAction: 'click:button',
      eventLabel: 'abrir-modal-compartilhar-imagem',
    })
  }

  const handleCloseShareModal = () => {
    setOpenShareModal(false)
  }

  if (!shouldShowComponent) {
    return null
  }
  return (
    <Suspense fallback={<LoadingFull />}>
      <IconButton
        autotagging-flora="on"
        aria-label="Compartilhar catálogo"
        data-flora-text="Compartilhar catálogo"
        onClick={handleOpenShareModal}
      >
        <ThreeLinkedDotsIcon
          size={HeaderCatalogVariants.SIZE_ICON}
          color={HeaderCatalogVariants.COLOR_ICON}
        />
      </IconButton>

      <ModalSocialShare
        imageUrl={catalogPageUrl}
        text={getModalShareText(reseller.catalogSlug, currentPage)}
        onClose={handleCloseShareModal}
        open={openShareModal}
      />
    </Suspense>
  )
}
